"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var AmsProfile = function AmsProfile(_ref) {
  var user = _ref.user,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? null : _ref$className,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["user", "className", "children"]);

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: className
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "py-8 grid grid-cols-2 gap-8"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "font-bold text-4xl text-center col-span-2"
  }, "Welcome: ", user.email), children));
};

var _default = {
  type: AmsProfile,
  props: {
    amsAction: "profile",
    authLevel: 0
  },
  wrappers: ["ams-profile"] // children: [
  //   { type: "ams-update-password" },
  //   { type: "ams-messages" }
  // ]

};
exports["default"] = _default;